import { ofType } from "redux-observable";
import { guard } from "../../../guards/guard";
import { TypeActionShowMe } from "../../actionShowMe";
import { checkEarnResourceTroughMarket } from "../../checks/checkEarnResourceTroughMarket";
import { pathOpenMarketMenu } from "../../path/pathOpenMarketMenu";
import { pathOpenShopOffers } from "../../path/pathOpenShopOffers";
export var epicShowMeEarnResource = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionShowMe.QuestTaskEarnResource), guard(state$, deps, pathOpenShopOffers)([
        checkEarnResourceTroughMarket(pathOpenMarketMenu),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/earn-resource/epicShowMeEarnResource.ts
// module id = 2362
// module chunks = 3